export const mpedStore = {
  dictionary: {},
  userData: {}
};
